module.exports = __webpack_public_path__ + "img/fayette-schools-logo.ee06e508.jpg";